import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function LoadingButton(): Components {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-text': {
            '&.MuiButton-loadingPositionStart .MuiButton-startIcon': {
              marginLeft: 0
            },
            '&.MuiButton-loadingPositionEnd .MuiButton-endIcon': {
              marginRight: 0
            }
          }
        }
      }
    }
  };
}
